import React, { useState, useEffect } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import mobileHelper from "../../../helpers/mobile";
import helpersNumbers from "../../../helpers/numbers";
import typeUser from "./TypeUser";
import TitleBar from "../../partials/content/TitleBar";
import user from "./UserExample";

export default function InfoCustomerCoworker() {
  return (
    <>
      <Sidebar activeItem="info-customer-coworker" />
      <div className="content-wrapper">
        <TitleBar title="اطلاعات شما" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="container">
                <div className="row">
                  <div className="table-responsive ">
                    <table className="table table-hilite tbl-td-white-space  ">
                      <thead>
                        <tr>
                          <td
                            colSpan={2}
                            className="text-center"
                            style={{ borderRadius: "25px 25px 0 0" }}
                          >
                            <b>اطلاعات شما</b>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <label>نوع کاربر</label>
                          </td>
                          <td>
                            <label>
                              {typeUser.userTypeString()[user.type]}
                            </label>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <label>نام</label>
                          </td>
                          <td>
                            <label>{user.firstName}</label>
                          </td>
                        </tr>

                        {user.type == typeUser.userType.REAL ? (
                          <tr>
                            <td>
                              <label>نام خانوادگی</label>
                            </td>
                            <td>
                              <label>{user.lastName}</label>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        <tr>
                          <td>
                            <label>ایمیل</label>
                          </td>
                          <td>
                            <label>{user.email}</label>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <label>شماره موبایل</label>
                          </td>
                          <td>
                            <label dir="ltr">
                              {helpersNumbers.toPersianNum(
                                mobileHelper.formatMobile(user.mobile)
                              )}
                            </label>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <label> دسته صنفی </label>
                          </td>
                          <td>
                            <label>{user.category}</label>
                          </td>
                        </tr>

                        {user.type == typeUser.userType.REAL ? (
                          <>
                            <tr>
                              <td>
                                <label> کد ملی </label>
                              </td>
                              <td>
                                <label>
                                  {helpersNumbers.toPersianNum(
                                    user.national_code
                                  )}
                                </label>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <label> شماره شناسنامه </label>
                              </td>
                              <td>
                                <label>
                                  {helpersNumbers.toPersianNum(
                                    user.identity_number
                                  )}
                                </label>
                              </td>
                            </tr>
                          </>
                        ) : (
                          <>
                            <tr>
                              <td>
                                <label> شناسه ملی </label>
                              </td>
                              <td>
                                <label>
                                  {helpersNumbers.toPersianNum(
                                    user.identity_national
                                  )}
                                </label>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <label> شماره اقتصادی </label>
                              </td>
                              <td>
                                <label>
                                  {helpersNumbers.toPersianNum(
                                    user.economic_number
                                  )}
                                </label>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <label> شماره ثبت </label>
                              </td>
                              <td>
                                <label>
                                  {helpersNumbers.toPersianNum(
                                    user.register_number
                                  )}
                                </label>
                              </td>
                            </tr>
                          </>
                        )}

                        <tr>
                          <td>
                            <label> استان </label>
                          </td>
                          <td>
                            <label>{user.state}</label>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <label> شهر </label>
                          </td>
                          <td>
                            <label>{user.city}</label>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <label> شهرستان </label>
                          </td>
                          <td>
                            <label>{user.town}</label>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <label> کدپستی </label>
                          </td>
                          <td>
                            <label>
                              {helpersNumbers.toPersianNum(user.postal_code)}
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label> شماره تلفن ثابت </label>
                          </td>
                          <td>
                            <label>
                              {helpersNumbers.toPersianNum(user.phone)}
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label> آدرس </label>
                          </td>
                          <td>
                            <label>{user.address}</label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label> توضیحات </label>
                          </td>
                          <td>
                            <label>
                              <p className="text-justify">
                                {" "}
                                {user.description}
                              </p>
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
